export const DOCUMENT_TYPE_EVENT_OPTIONS: SelectItem[] = [
  { label: 'Termo de Cessão', value: 'assignment' },
  { label: 'Contrato de Cessão', value: 'transfer' },
  { label: 'Duplicatas', value: 'duplicates' },
];

const DEFAULT_EVENT_LABEL = 'Nenhum evento vinculado';

export function mapMinuteTypeEventOptions(response: unknown): SelectItem[] {
  const payload = response as {
    data?: unknown;
    results?: unknown;
  };

  const events = Array.isArray(response)
    ? response
    : Array.isArray(payload?.data)
      ? payload.data
      : Array.isArray(payload?.results)
        ? payload.results
        : [];

  return events
    .map((item) => ({
      label:
        item.label ?? item.name ?? item.display ?? item.event_display,
      value:
        item.value ?? item.slug ?? item.key ?? item.event ?? item.id,
    }))
    .filter((item) => item.label && item.value != null);
}

export function getDocumentTypeEventLabel(
  event?: string | null,
  options: SelectItem[] = DOCUMENT_TYPE_EVENT_OPTIONS,
  fallback = DEFAULT_EVENT_LABEL,
): string {
  if (!event) {
    return fallback;
  }

  const found = options.find((item) => item.value === event);
  return found?.label ?? fallback;
}
